export default "/_next/static/chunks/fonts/SourceSans3-SemiBold-latin-55ac6bc1f02315d77748a5dc7b00fa9e.woff2";